<template>
  <div id="file-upload-content">
    <file-uploader-vue
      class="upload"
      @onFileChange="handleChangeImg"
      :fileAccept="fileAccept"
      :multifile="multifile"
    >
      <div class="upload-content flex-center">
        <div class="upload-btn">{{ title }}</div>
      </div>
    </file-uploader-vue>
  </div>
</template>

<script>
import fileUploaderVue from './file-uploader.vue';
export default {
  name: 'file-uploadContent',
  props: {
    fileAccept: {
      type: String,
      default: '.jpg,.png,.jpeg'
    },
    title: {
      type: String,
      default: '选择图片上传'
    },
    multifile: {
      type: Boolean,
      default: true
    }
  },
  components: {
    fileUploaderVue
  },
  methods: {
    handleChangeImg({ files }) {
      this.$emit('onFileChange', { files });
    }
  }
};
</script>

<style lang="scss">
#file-upload-content {
  .upload {
    background-color: #ddd;
    &-content {
      width: 100%;
      height: 173px;
      background-color: #ddd;
    }
    &-btn {
      width: 121px;
      height: 36px;
      background-color: $color-primary;
      color: #fff;
      line-height: 36px;
      text-align: center;
      border-radius: 4px;
    }
  }
}
</style>
